module.exports = __webpack_public_path__ + "img/expense-union.5e256c01.svg";